__turbopack_context__.v({
  "caption-in": "product-demo-caption-module__kRPCvq__caption-in",
  "enter": "product-demo-caption-module__kRPCvq__enter",
});
